import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Typography,
  InputLabel,
  Tooltip,
  styled,
  Stack,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { useDebounce } from "use-debounce";
import AuthContext from "../../Context/auth/AuthContext";

// Componentes estilizados
const StyledInput = styled("input")({
  display: "none",
});

const StyledImage = styled("img")({
  height: 300,
  width: 300,
  objectFit: "cover",
  borderRadius: 12,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
});

export default function AddProfileImage({ open, handleClose, id }) {
  const miImagen = require("../../assets/img/default .png");
  const [image, setImage] = useState({
    urlPhoto: miImagen,
    image: "",
  });
  const [debouncedFile] = useDebounce(image.image, 500);

  const { AddProfileImage } = useContext(AuthContext);

  const handleChangeImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage({
        urlPhoto: URL.createObjectURL(file),
        image: file,
      });
    }
  };

  useEffect(() => {
    if (debouncedFile) {
      handleClose();
      AddProfileImage({ client_id: id, image: debouncedFile });
    }
  }, [debouncedFile]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle textAlign='center'>Subir Foto de Perfil</DialogTitle>
      <DialogContent>
        <Stack spacing={3} alignItems='center'>
          <StyledImage src={image.urlPhoto} alt='Vista previa' />
          <InputLabel htmlFor='upload-button' sx={{ cursor: "pointer" }}>
            <StyledInput
              accept='image/png, image/jpg, image/jpeg, image/webp'
              id='upload-button'
              type='file'
              onChange={handleChangeImage}
            />
            <Tooltip title='Seleccionar imagen' placement='top'>
              <IconButton component='span' color='primary'>
                <PhotoCameraIcon fontSize='large' />
              </IconButton>
            </Tooltip>
            <Typography variant='body2' textAlign='center'>
              Click en el ícono para seleccionar una imagen
            </Typography>
          </InputLabel>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
